module.exports = __webpack_public_path__ + "img/Anthropologie_logo.92789857.svg";